import parse from 'html-react-parser'
import React, { PropsWithChildren } from 'react'
import { useTheme } from 'styled-components'

import Headline from '@components/atoms/Headline'
import { HeadlineImportances } from '@components/atoms/Headline/Headline'
import IconCheckmark from '@components/atoms/Icons/IconCheckmark'
import IconMarker from '@components/atoms/Icons/IconMarker'
import IconPhone from '@components/atoms/Icons/IconPhone'
import Text from '@components/atoms/Text'
import { TextVariants } from '@components/atoms/Text/Text'

import { parseOptions } from '@helper/parseOptions'
import { PropsWithClassName } from '@helper/PropsWithClassName'

import { Root, TextLink } from './AddressDetails.styles'

interface Props extends PropsWithClassName {
  address: string
  phone?: string
  route?: string
  parkingAvailable?: boolean
}

const AddressDetails: React.FC<PropsWithChildren<Props>> = (
  props: PropsWithChildren<Props>
): React.ReactElement => {
  const { address, phone, route, parkingAvailable } = props

  const theme: any = useTheme()

  return (
    <Root className={props.className} data-testid={'address-details-root'}>
      <Headline importance={HeadlineImportances.h4}>
        Kontakt und Studiodetails
      </Headline>
      {address ? <address>{parse(address, parseOptions)} </address> : null}
      {phone ? (
        <Text variant={TextVariants.paragraph}>
          <IconPhone color={theme.palette.default.primary} />{' '}
          <TextLink href={`tel:${phone}`}>{phone}</TextLink>
        </Text>
      ) : null}
      {route ? (
        <Text variant={TextVariants.paragraph}>
          <IconMarker color={theme.palette.default.primary} size="16" />{' '}
          <TextLink href={route}>Routenplaner</TextLink>
        </Text>
      ) : null}
      {parkingAvailable ? (
        <Text variant={TextVariants.paragraph}>
          <IconCheckmark color={theme.palette.default.primary} size="16" />{' '}
          <b>Parkplätze vorhanden</b>
        </Text>
      ) : null}
    </Root>
  )
}

export { AddressDetails }
